/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';

/**
 * Provides a utility hook setting to true then, after delay, resetting the
 * refresh state to false.
 *
 * ```typescript
 *   import {useRefresh} from '@ion/dls/src/hooks/useRefresh';
 *
 *   const SomeComponent = () => {
 *     const refresh = useRefresh();
 *   }
 *
 * ```
 */
export const useRefresh = (trigger, delay = 500) => {
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setRefresh(true);
    setTimeout(() => {
      setRefresh(false);
    }, delay);
  }, [trigger]);
  return refresh;
};
export default useRefresh;
